import { enableProdMode } from '@angular/core';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';

import { registerPlugin } from 'filepond';

import { provideNoopAnimations } from '@angular/platform-browser/animations';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import { userInterceptor } from './app/core/interceptors/user.interceptor';

registerPlugin(
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginImageEdit
);


bootstrapApplication(AppComponent,  {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([userInterceptor])),
    provideAngularSvgIcon(),
    provideNoopAnimations(),
  
  ]
})
  .catch(err => console.error(err)); 
  
if (environment.production) {
  enableProdMode();
}



